import React from 'react';

import { Typography } from '@mui/material';

import { useCommonHeaderStyles } from '../Header/style';

export interface ExpertInfoProps {
  name?: string | null;
  jobTitle?: string | null;
  description?: string | null;
}

const ExpertInfo: React.FC<ExpertInfoProps> = ({ name, jobTitle, description }) => {
  const headerClasses = useCommonHeaderStyles();
  return (
    <>
      {name && (
        <Typography variant="h2" className={headerClasses.searchTitle}>
          {name}
        </Typography>
      )}
      {jobTitle && <Typography className={headerClasses.searchSubtitle}>{jobTitle}</Typography>}
      {description && (
        <Typography className={headerClasses.searchDescription}>{description}</Typography>
      )}
    </>
  );
};

export default ExpertInfo;
